import { observable, autorun, makeObservable } from 'mobx'

class DivisionStore {
    @observable filteredList = []

    divisions = []

    divisionName = ''

    portfolios = []

    @observable availableTags = []

    @observable formFields = []

    @observable formLoading = true

    @observable recordTags = {}

    constructor(store) {
        makeObservable(this)
        this.appStore = store

        autorun(() => {
            if (this.formFields.length > 0) this.formLoading = false
        })
    }

    initSearch = async () => {
        try {
            this.divisions = await this.getDivisions()
            this.filteredList = this.divisions
        } catch (error) {
            console.log('DivisionStore.jsx initSearch error ', error)
        }
    }

    // used in DivisionEdit.jsx
    initDivision = async (divisionId, handleCloseModal) => {
        try {
            this.availableTags = await this.appStore.getAvailableTags({
                oid: 4,
                industry: this.industry,
            })
            if (divisionId !== 0) {
                const division = await this.getDivision(divisionId)
                this.divisionName = division.name
                this.portfolios = await this.getPortfolios(divisionId)
                this.recordTags = await this.appStore.getRecordTags(4, divisionId)
            } else {
                this.divisionName = ''
                this.recordTags = {}
            }

            this.defineFormFields()
        } catch (error) {
            console.error('DivisionStore.jsx initDivision error ', error)
            handleCloseModal()
        }
    }

    defineFormFields = () => {
        this.formFields = [
            {
                type: 'input',
                name: 'divisionName',
                label: 'Name',
                placeholder: 'Enter division name',
                defaultValue: this.divisionName,
                isMandatory: true,
                errorMessage: 'Division name required',
            },
        ]
    }

    setField = async ({ value, name }) => {
        console.log(`setField ${value} => ${name}`)
        this.divisionName = value
    }

    resetFormState = () => {
        this.formFields = []
        this.divisionName = ''
    }

    getDivisions = () => (this.appStore.http.get('/division'))

    getDivision = (divisionId) => (this.appStore.http.get(`/division/${divisionId}`))

    getPortfolios = (divisionId) => (this.appStore.http.get(`/division/${divisionId}/portfolio`))

    search = () => {
        const { searchStr } = this.searchModule
        if (searchStr === '') {
            this.filteredList = this.divisions
        } else if (!Number.isNaN(parseInt(searchStr, 10))) {
            this.filteredList = this.divisions
                .filter((d) => d.divisionId === parseInt(searchStr, 10))
        } else {
            const re = new RegExp(searchStr, 'i')
            this.filteredList = this.divisions
                .filter((d) => d.name.match(re))
        }
    }

    update = async (obj) => {
        const response = await this.appStore.http.put(`/division/${obj.divisionId}`, JSON.stringify(obj))
        await this.saveTags(obj.divisionId)
        return response
    }

    save = async (obj) => {
        const response = await this.appStore.http.post('/division', JSON.stringify(obj))
        await this.saveTags(response.divisionId)
        return response
    }

    getDivision = async (divisionId) => {
        const d = this.appStore.http.get(`/division/${divisionId}`)
        console.log(d)
        return d
    }

    /** Tags */
    getAvailableTags = async () => {
        const { appStore } = this

        this.availableTags = await appStore.getAvailableTags({ oid: 4, industry: 'EV' })
    }

    getDivisionTags = async (divisionId) => {
        const { appStore } = this
        let tags = {}

        if (divisionId !== 0) {
            tags = await appStore.getRecordTags(4, divisionId)
        }

        this.recordTags = tags
    }

    setTag = ({ name, value }) => {
        this.recordTags[name] = value
    }

    saveTags = async (recordId) => {
        const { appStore } = this
        const { availableTags, recordTags } = this
        try {
            appStore.saveTags(recordId, 4, availableTags, recordTags)
        } catch (e) {
            console.error(e)
        }
    }
    /** end Tags */
}

export default DivisionStore
